/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React, { memo } from 'react';
import { DataContextProvider } from '@forge/data-connector';
import IEnergyManagementProps from '../../DashboardKPIWidgets/IEnergyManagementProps';
import EmaasEnergyUsagesViewDetailComponent from './EmaasEnergyUsagesViewDetailComponent';
import { ContextProvider, updateApiConfig } from '../../../context/ApiContext';
import { shouldComponentNotUpdateOnDateChange } from '../../shared/Utils/Utils';
import { FilterScope1Provider } from '../../../context/FilterScope1Context/FilterScope1Context';
import { withLocalization } from '../../../locales/withLocalization';

const emaasEnergyUsagesViewDetails = memo((props: IEnergyManagementProps) => {
  const {
    connectorConfig,
    bearerToken,
    requestContext,
    emaasContext,
    getAllMeterData
  } = props;

  return (
    <ContextProvider
      value={updateApiConfig({
        connectorConfig,
        ...emaasContext
      })}
    >
      <DataContextProvider config={connectorConfig}>
        <FilterScope1Provider>
          <div className="energy-viewdetails-dashboard">
            <EmaasEnergyUsagesViewDetailComponent
              requestContext={requestContext}
              bearerToken={bearerToken}
              connectorConfig={connectorConfig}
              emaasContext={emaasContext}
              getAllMeterData={getAllMeterData}
            />
          </div>
        </FilterScope1Provider>
      </DataContextProvider>
    </ContextProvider>
  );
}, shouldComponentNotUpdateOnDateChange);

export default withLocalization<IEnergyManagementProps>(
  emaasEnergyUsagesViewDetails
);
